import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeaderContextual.styles'

const t = document.createElement('template')
t.innerHTML = `
  <span class="contextual-title"><slot></slot></span>
`

class NavHeaderContextualTitle extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {}
}

if (!customElements.get('ts-navheader-contextual-title')) {
  customElements.define('ts-navheader-contextual-title', NavHeaderContextualTitle)
}
export { NavHeaderContextualTitle }
